import {VictoryPointTypes, VictoryPointStateReader} from '@colonist/game-base-types'
import {ArrayUtils} from '@colonist/utils'
import {EndGamePlayerState, PlayerColor} from '@colonist/game-states'

export class EndGameStateUtils {
    static getPlayerRank(color: PlayerColor, players: {[key in PlayerColor]?: EndGamePlayerState}): number {
        const player = players[color]
        return player?.rank ?? 0
    }

    static getPlayersSortedByRank(players: {[key in PlayerColor]?: EndGamePlayerState}): EndGamePlayerState[] {
        const playersArray = Object.values(players)
        playersArray.sort((a, b) => a.rank - b.rank)
        return playersArray
    }

    static highestVictoryPointScoreOfType(victoryPointType: VictoryPointTypes, players: {[key in PlayerColor]?: EndGamePlayerState}): number {
        let highestVictoryPointScoreOfType: number = 0
        const playersArray = Object.values(players)
        for(const player of playersArray) {
            const playerVictoryPointsOfType = VictoryPointStateReader.totalVictoryPointsOfType(player.victoryPoints, [victoryPointType])
            if(playerVictoryPointsOfType <= highestVictoryPointScoreOfType) continue
            highestVictoryPointScoreOfType = playerVictoryPointsOfType
        }
        return highestVictoryPointScoreOfType
    }

    static getAllUniqueVictoryPointsEarnedByAllPlayers(players: {[key in PlayerColor]?: EndGamePlayerState}): VictoryPointTypes[] {
        const allUniqueVictoryPoints: VictoryPointTypes[] = []
        const playersArray = Object.values(players)
        for(const player of playersArray) {
            const allUniqueVictoryPointsForPlayer = VictoryPointStateReader.getAllUniqueVictoryPointTypesEarned(player.victoryPoints)
            for(const uniqueVictoryPoint of allUniqueVictoryPointsForPlayer) {
                if(ArrayUtils.elementInArray(allUniqueVictoryPoints, uniqueVictoryPoint)) continue
                allUniqueVictoryPoints.push(uniqueVictoryPoint)
            }
        }
        return allUniqueVictoryPoints.sort()
    }
}
